// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-marker {
    display: grid;
    grid-template-columns: 0.25fr auto;
    opacity: 0.8 !important;
    transition: all 300ms ease-in-out;
}

div.custom-marker.left .info {
    left: 0;
    right: 1.25vw;
}

div.custom-marker.left .info .site-name {
    text-align: right;
}

div.custom-marker.left .info .site-name p {
    transform: rotateY(180deg);
}

div.custom-marker.left .info .priority-ratings p {
    transform: rotateY(180deg);
}

div.custom-marker.left .info .priority-ratings p:nth-of-type(even) {
    text-align: right;
}


.custom-marker:hover {
    position: absolute;
    z-index: 9999;
    cursor: pointer;
    opacity: 1 !important;
}

.custom-marker .circle {
    padding: 0.1vw;
    border-radius: 50%;
    display: grid;
    place-content: center;
}

.custom-marker .circle .inner-cirlce {
    width: 0.8vw;
    aspect-ratio: 1/1;
    border-radius: 50%;
    border: 0.2vw solid black;
}

.custom-marker .info {
    position: absolute;
    left: 1.25vw;
}

.custom-marker .site-details {
    display: grid;
    grid-template-columns: auto 0.1fr;
    height: 1.75vw;
}

.custom-marker .site-details .site-name {
    box-sizing: border-box;
    background: black;
    color: white;
    font-size: 0.85vw;
    font-weight: bold;
    display: grid;
    align-items: center;
    text-align: left;
    padding-left: 1vw;
    box-sizing: border-box;
}

.custom-marker .site-details .site-name p {
    padding: 0;
    margin: 0;
}

.custom-marker .info .site-details .end-adornment {
    position: relative;
    left: -1vw;
    width: 2vw;
}

.custom-marker .info .priority-info {
    position: absolute;
    top: 0;
    width: inherit;
    box-sizing: border-box;
    visibility: hidden;
    transition: opacity 250ms ease-in-out, visibility 300ms ease-in-out;
    opacity: 0;
}

.custom-marker:hover .info .priority-info {
    visibility: visible;
    opacity: 1;
}

.custom-marker .info .priority-info .priority-ratings {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 0.2fr 1fr;
    align-items: start;
    column-gap: 0.25vw;
    row-gap: 0.5vh;
    line-height: 1;
    text-align: left;
    box-sizing: border-box;
}

.custom-marker .info .priority-info svg path {
    fill: var(--text-light);
    stroke: var(--text-dark);
    stroke-width: 0.125vw;
}

.custom-marker .info .priority-ratings>p {
    padding: 0;
    font-size: 0.75rem;
    line-height: 0.75rem;
    margin: 0.25vw 0;
    font-weight: 500;
}

.custom-marker .info .priority-ratings>p:nth-of-type(odd) {
    font-weight: bold;
    text-align: center;
}

.custom-marker .info .priority-ratings>p.high-priority {
    color: var(--high-rating-color)
}

.custom-marker .info .priority-ratings>p.high_medium-priority {
    color: var(--high_medium-rating-color)
}

.custom-marker .info .priority-ratings>p.medium-priority {
    color: var(--medium-rating-color)
}

.custom-marker .info .priority-ratings>p.low-priority {
    color: var(--low-rating-color)
}

.custom-marker.high-rating .circle {
    border: 0.2vw solid var(--high-rating-color);
}

.custom-marker.high-rating .circle .inner-cirlce {
    background: var(--high-rating-color)
}

.custom-marker.high-medium-rating .circle {
    border: 0.2vw solid var(--high_medium-rating-color);
}

.custom-marker.high-medium-rating .circle .inner-cirlce {
    background: var(--high_medium-rating-color)
}

.custom-marker.medium-rating .circle {
    border: 0.2vw solid var(--medium-rating-color);
}

.custom-marker.medium-rating .circle .inner-cirlce {
    background: var(--medium-rating-color)
}

.custom-marker.low-rating .circle {
    border: 0.2vw solid var(--low-rating-color);
}

.custom-marker.low-rating .circle .inner-cirlce {
    background: var(--low-rating-color)
}

.custom-marker.high-rating .end-adornment {
    background: var(--high-rating-color);
}

.custom-marker.high-medium-rating .end-adornment {
    background: var(--high_medium-rating-color);
}

.custom-marker.medium-rating .end-adornment {
    background: var(--medium-rating-color);
}

.custom-marker.low-rating .end-adornment {
    background: var(--low-rating-color);
}

.maplibregl-ctrl-bottom-right {
    display: none !important;
}

div.custom-marker.high-rating .circle::after,
div.custom-marker.high-medium-rating .circle::after {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    height: 100%;
    width: 100%;
    border-radius: 100%;
    animation-name: ripple;
    animation-duration: 800ms;
    animation-delay: 0;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(.65, 0, .34, 1);
    z-index: -1;
}

div.custom-marker.high-rating .circle::after {
    background-color: var(--high-rating-color);
}

div.custom-marker.high-medium-rating .circle::after {
    background-color: var(--high_medium-rating-color);
    animation-duration: 1100ms;
}`, "",{"version":3,"sources":["webpack://./src/components/maps/OpenStreetMapWithMarkers.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,mEAAmE;IACnE,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI;AACJ;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI;AACJ;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI;AACJ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,mCAAmC;IACnC,uDAAuD;IACvD,WAAW;AACf;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iDAAiD;IACjD,0BAA0B;AAC9B","sourcesContent":[".custom-marker {\n    display: grid;\n    grid-template-columns: 0.25fr auto;\n    opacity: 0.8 !important;\n    transition: all 300ms ease-in-out;\n}\n\ndiv.custom-marker.left .info {\n    left: 0;\n    right: 1.25vw;\n}\n\ndiv.custom-marker.left .info .site-name {\n    text-align: right;\n}\n\ndiv.custom-marker.left .info .site-name p {\n    transform: rotateY(180deg);\n}\n\ndiv.custom-marker.left .info .priority-ratings p {\n    transform: rotateY(180deg);\n}\n\ndiv.custom-marker.left .info .priority-ratings p:nth-of-type(even) {\n    text-align: right;\n}\n\n\n.custom-marker:hover {\n    position: absolute;\n    z-index: 9999;\n    cursor: pointer;\n    opacity: 1 !important;\n}\n\n.custom-marker .circle {\n    padding: 0.1vw;\n    border-radius: 50%;\n    display: grid;\n    place-content: center;\n}\n\n.custom-marker .circle .inner-cirlce {\n    width: 0.8vw;\n    aspect-ratio: 1/1;\n    border-radius: 50%;\n    border: 0.2vw solid black;\n}\n\n.custom-marker .info {\n    position: absolute;\n    left: 1.25vw;\n}\n\n.custom-marker .site-details {\n    display: grid;\n    grid-template-columns: auto 0.1fr;\n    height: 1.75vw;\n}\n\n.custom-marker .site-details .site-name {\n    box-sizing: border-box;\n    background: black;\n    color: white;\n    font-size: 0.85vw;\n    font-weight: bold;\n    display: grid;\n    align-items: center;\n    text-align: left;\n    padding-left: 1vw;\n    box-sizing: border-box;\n}\n\n.custom-marker .site-details .site-name p {\n    padding: 0;\n    margin: 0;\n}\n\n.custom-marker .info .site-details .end-adornment {\n    position: relative;\n    left: -1vw;\n    width: 2vw;\n}\n\n.custom-marker .info .priority-info {\n    position: absolute;\n    top: 0;\n    width: inherit;\n    box-sizing: border-box;\n    visibility: hidden;\n    transition: opacity 250ms ease-in-out, visibility 300ms ease-in-out;\n    opacity: 0;\n}\n\n.custom-marker:hover .info .priority-info {\n    visibility: visible;\n    opacity: 1;\n}\n\n.custom-marker .info .priority-info .priority-ratings {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    grid-template-columns: 0.2fr 1fr;\n    align-items: start;\n    column-gap: 0.25vw;\n    row-gap: 0.5vh;\n    line-height: 1;\n    text-align: left;\n    box-sizing: border-box;\n}\n\n.custom-marker .info .priority-info svg path {\n    fill: var(--text-light);\n    stroke: var(--text-dark);\n    stroke-width: 0.125vw;\n}\n\n.custom-marker .info .priority-ratings>p {\n    padding: 0;\n    font-size: 0.75rem;\n    line-height: 0.75rem;\n    margin: 0.25vw 0;\n    font-weight: 500;\n}\n\n.custom-marker .info .priority-ratings>p:nth-of-type(odd) {\n    font-weight: bold;\n    text-align: center;\n}\n\n.custom-marker .info .priority-ratings>p.high-priority {\n    color: var(--high-rating-color)\n}\n\n.custom-marker .info .priority-ratings>p.high_medium-priority {\n    color: var(--high_medium-rating-color)\n}\n\n.custom-marker .info .priority-ratings>p.medium-priority {\n    color: var(--medium-rating-color)\n}\n\n.custom-marker .info .priority-ratings>p.low-priority {\n    color: var(--low-rating-color)\n}\n\n.custom-marker.high-rating .circle {\n    border: 0.2vw solid var(--high-rating-color);\n}\n\n.custom-marker.high-rating .circle .inner-cirlce {\n    background: var(--high-rating-color)\n}\n\n.custom-marker.high-medium-rating .circle {\n    border: 0.2vw solid var(--high_medium-rating-color);\n}\n\n.custom-marker.high-medium-rating .circle .inner-cirlce {\n    background: var(--high_medium-rating-color)\n}\n\n.custom-marker.medium-rating .circle {\n    border: 0.2vw solid var(--medium-rating-color);\n}\n\n.custom-marker.medium-rating .circle .inner-cirlce {\n    background: var(--medium-rating-color)\n}\n\n.custom-marker.low-rating .circle {\n    border: 0.2vw solid var(--low-rating-color);\n}\n\n.custom-marker.low-rating .circle .inner-cirlce {\n    background: var(--low-rating-color)\n}\n\n.custom-marker.high-rating .end-adornment {\n    background: var(--high-rating-color);\n}\n\n.custom-marker.high-medium-rating .end-adornment {\n    background: var(--high_medium-rating-color);\n}\n\n.custom-marker.medium-rating .end-adornment {\n    background: var(--medium-rating-color);\n}\n\n.custom-marker.low-rating .end-adornment {\n    background: var(--low-rating-color);\n}\n\n.maplibregl-ctrl-bottom-right {\n    display: none !important;\n}\n\ndiv.custom-marker.high-rating .circle::after,\ndiv.custom-marker.high-medium-rating .circle::after {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: '';\n    height: 100%;\n    width: 100%;\n    border-radius: 100%;\n    animation-name: ripple;\n    animation-duration: 800ms;\n    animation-delay: 0;\n    animation-iteration-count: infinite;\n    animation-timing-function: cubic-bezier(.65, 0, .34, 1);\n    z-index: -1;\n}\n\ndiv.custom-marker.high-rating .circle::after {\n    background-color: var(--high-rating-color);\n}\n\ndiv.custom-marker.high-medium-rating .circle::after {\n    background-color: var(--high_medium-rating-color);\n    animation-duration: 1100ms;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
